import Styles from '../ShapesTab.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { Scissors4 } from 'blaze-ui/icons'
import ToggleButton from 'common/ToggleButton/ToggleButton'
import { Editor, track } from '@tldraw/tldraw'
import { ImageShape } from 'components/VisualStudioPlayground/Shapes/ImageShape/Types'
import { observer } from 'mobx-react-lite'
import { useToggleRemoveBackground } from 'components/Design/utils/useToggleRemoveBackground'
import { Pressable } from '@react-aria/interactions'

interface Props {
  editor: Editor
  shape: ImageShape
}

export const CutoutToggle = track(
  observer(({ editor, shape }: Props) => {
    const { toggle, value, isDisabled } = useToggleRemoveBackground({ editor, shape })

    if (isDisabled) {
      return null
    }

    return (
      <div className={Styles.colorSection}>
        <Pressable onPress={() => toggle()}>
          <div className={Styles.actionRow}>
            <Scissors4 color="var(--selected-fill)" />
            <span className={Styles.actionName}>
              <Text variant="smallList">Remove Background</Text>
            </span>
            <ToggleButton name="cutout" size="sm-md" checked={value} handleChange={() => {}} />
          </div>
        </Pressable>
      </div>
    )
  }),
)
